import * as React from 'react';
import type { FC } from 'react';
import useInputErrorsDebouncer from 'app/useInputErrorsDebouncer';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { Errors, Values, ChangeValues } from './types';
import Spinner from './Spinner';
import EmailIcon from './images/icon_mail.svg';
import { INVALID_EMAIL_FORMAT_ERROR } from './useEmailValidation';

const Email: FC<{
  values: Values;
  changeValues: ChangeValues;
  errors: Errors;
  locales: Locales;
  isValidating: boolean;
}> = ({ values, changeValues, errors, locales, isValidating }) => {
  const { email } = values;
  const [canShowErrors, delayErrors] = useInputErrorsDebouncer();
  const showErrors = email && canShowErrors;
  const emailErrors = errors.email || [];
  const notFormatErrors = emailErrors.filter((e) => e !== INVALID_EMAIL_FORMAT_ERROR).join(', ');

  return (
    <div className={`input player_email ${showErrors && emailErrors.length ? 'error' : ''}`}>
      <div className="input-with-icon xo-form_input-iconfull">
        <input
          autoComplete="off"
          placeholder={translation(locales, 'email.placeholder')}
          type="email"
          name="player[email]"
          id="player_email"
          value={email}
          className="sign_input xo-form_input"
          onChange={(e) => {
            changeValues({ email: e.target.value });
            delayErrors();
          }}
        />
        <label htmlFor="player_email" className="xo-form_input-label">
          <span className="xo-form_label-placeholder">{translation(locales, 'email.placeholder')}</span>
          <span className="xo-form_input-image">
            <img src={EmailIcon} alt="icon" />
          </span>
        </label>
        <span className="icon" />
        {isValidating && <Spinner />}
      </div>
      {showErrors && (
        <div className="hints">
          <small className="error">{notFormatErrors}</small>
        </div>
      )}
    </div>
  );
};

export default Email;
